import { useContext } from 'react'
import MunicipalityContext from 'app/contexts/MunicipalityContext'

const useMunicipality = () => useContext(MunicipalityContext)

export default useMunicipality